import { useState, useEffect } from 'react';

function MenuActividadEconomica(props) {
    const [idUsuario, setIdUsuario] = useState();
    const [fechaSistema, setFechaSistema] = useState(localStorage.getItem('fechasistema'));
    const [espiritu, setEspiritu] = useState(localStorage.getItem('espiritu'));

    useEffect(() => {
        setPermisos(JSON.parse(localStorage.getItem('permisos')));
        let obj = JSON.parse(localStorage.getItem('post'));
        setIdUsuario(obj.idusuario);
        setFechaSistema(obj.fechasistema);
        setEspiritu(obj.espiritu);
    }, [props.permisos]);

    const menu = ''


    return menu;

} export default MenuActividadEconomica;